import RestService from '../services/rest';

async function createPunchOutRule({
  code,
  name,
  description,
  type,
}) {
  return RestService.postAuthenticated('panel/punchoutRules/create', {
    code,
    name,
    description,
    type,
  });
}

async function updatePunchOutRule({
  ruleId,
  name,
  description,
  type,
}) {
  return RestService.putAuthenticated('panel/punchoutRules/update', {
    ruleId,
    name,
    description,
    type,
  });
}

async function getPunchOutRules(limit, skip, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/punchoutRules/getAllRules?limit=${limit}&skip=${skip}&order=${order}&field=${field}`,
  );
}

export default {
  createPunchOutRule,
  getPunchOutRules,
  updatePunchOutRule,
};
